import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowUpCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M12 2c-3.17 0-5.715.793-7.461 2.539S2 8.829 2 12c0 3.17.793 5.715 2.539 7.461S8.829 22 12 22c3.17 0 5.715-.793 7.461-2.539S22 15.171 22 12c0-3.17-.793-5.715-2.539-7.461S15.171 2 12 2m-3.182 9.94a1 1 0 0 1-.707-1.708l3.182-3.182a1 1 0 0 1 1.414 0l3.182 3.182a1 1 0 0 1-.707 1.707H13v4.304a1 1 0 1 1-2 0v-4.304z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowUpCircle)
export default ForwardRef
